import type { ReactNode } from 'react';

export type Phase = {
  key: string;
  sport: string;
  phase: string;
  // Months (0 = January) the phase is running. Drives the card order: a phase in season
  // leads, so October opens on the regular season rather than the NFL preseason (#2142).
  months: number[];
  body: ReactNode;
};

/**
 * The month (0 = January) in Pacific time, where release times are stated. The page is
 * server-rendered (UTC) and hydrated in the visitor's zone; reading the month in one
 * fixed zone keeps both sides on the same order across a month boundary.
 */
export function pacificMonth(now: Date): number {
  const month = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    month: 'numeric',
  }).format(now);
  return Number(month) - 1;
}

/** In-season phases first; otherwise the listed order (a stable sort keeps it). */
export function orderPhases(phases: Phase[], now: Date) {
  const month = pacificMonth(now);
  return phases
    .map((phase) => ({ phase, inSeason: phase.months.includes(month) }))
    .sort((a, b) => Number(b.inSeason) - Number(a.inSeason));
}
